import { Sheet, SheetContent, SheetTitle, SheetDescription } from '@/shared/widgets/sheet';
import { Input } from '@/shared/widgets/input';

export interface PincodePopupV2Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  inputValue: string;
  error?: string | null;
  onChange: (value: string) => void;
  onSubmit: () => void | Promise<void>;
  description?: string;
}

export interface PincodePopupContentV2Props {
  inputValue: string;
  error?: string | null;
  onChange: (value: string) => void;
  onSubmit: () => void | Promise<void>;
  onClose: () => void;
  description?: string;
}

export function PincodePopupContentV2({
  inputValue,
  error,
  onChange,
  onSubmit,
  onClose,
}: PincodePopupContentV2Props) {
  return (
    <div className="bg-white px-4 pb-[max(50px,env(safe-area-inset-bottom))] text-[#202020]">
      <button
        type="button"
        onClick={onClose}
        aria-label="Close pincode availability"
        className="mx-auto flex h-9 w-14 items-center justify-center rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#15366F]"
      >
        <span aria-hidden className="h-1 w-10 rounded-full bg-[#D5C9B9]" />
      </button>
      <div className="px-1 pt-1">
        <SheetTitle className="text-xl font-normal leading-7 tracking-normal">
          Check Availability In Your Pincode
        </SheetTitle>
        <SheetDescription className="mt-1 text-sm leading-5 text-[#8D7F73]">
          Browse our exquisite designs in nearby BlueStone stores
        </SheetDescription>
      </div>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit();
        }}
        className="mt-6"
      >
        <label htmlFor="plp-pincode-input-v2" className="mb-2 block text-xs leading-4">
          Pincode
        </label>
        <Input
          id="plp-pincode-input-v2"
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          value={inputValue}
          onChange={(event) => onChange(event.target.value)}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? 'plp-pincode-error-v2' : undefined}
          className="h-10 rounded-lg border border-[#E8E8E8] bg-white px-2 text-xs shadow-none focus-visible:ring-[#15366F]"
          placeholder="Pincode"
        />
        {error && <p id="plp-pincode-error-v2" role="alert" className="mt-2 text-xs text-red-500">{error}</p>}
        <button
          type="submit"
          className="mt-2.5 h-10 w-full rounded-xl bg-[#15366F] text-sm font-normal text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#15366F] focus-visible:ring-offset-2"
        >
          Apply
        </button>
      </form>
    </div>
  );
}

export function PincodePopupV2({
  open,
  onOpenChange,
  inputValue,
  error,
  onChange,
  onSubmit,
  description,
}: PincodePopupV2Props) {
  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        showCloseButton={false}
        className="animate-bottom-sheet inset-x-0 bottom-0 h-auto max-h-[85dvh] overflow-y-auto rounded-t-[32px] rounded-b-none border-0 bg-white p-0 gap-0"
      >
        <PincodePopupContentV2
          inputValue={inputValue}
          error={error}
          onChange={onChange}
          onSubmit={onSubmit}
          onClose={handleClose}
          description={description}
        />
      </SheetContent>
    </Sheet>
  );
}
